<div class="card" style="margin-top: -30px;">
    <div class="card-header">
        <h4>Screening Configuration</h4>
    </div>
    <div>
    <div class="row">
        <div class="col-lg-12">
            <div class="card border-0 shadow-none text-center">
                <div class="card-body">
                    <div class="row d-flex">
                        <div class="form-group col-md-3">
                            <label class="col-form-label">UserType</label>
                            <ng-select id="userType" (change)="getTypeData($event)" [(ngModel)]="userType" placeholder="Select User Type">
                               <ng-option value="CUSTOMER">Customer</ng-option>
                              <ng-option value="MERCHANT">Merchant</ng-option>
                              <ng-option value="RESELLER">Reseller</ng-option>
                              <ng-option value="INDIVIDUAL">UBO-Individual</ng-option>
                              <ng-option value="ENTITY">UBO-Entity</ng-option>
                              <ng-option value="POA">UBO-POA</ng-option>
                              <ng-option value="AGENT">Agent</ng-option>
                              <ng-option value="SUBAGENT">Subagent</ng-option>
                            </ng-select>
                        </div>
                    </div>  
                    <hr>
                    <div class="row d-flex" *ngIf="userType!=undefined">
                        <div class="form-group col-md-4"></div>
                        <div class="form-group col-md-4">
                        <h4 class="d-flex">{{userType | titlecase}} Screening Configuration <div class="social-icons">
                            <a class="social-icon">
                              <i class="feather icon-info"></i>
                              <div class="tooltip">Screening configuration is only for who have this functionality</div>
                            </a>
                          </div></h4>
                        </div>
                        <div class="form-group col-md-4"></div>
                    </div> 
                    <div class="row d-flex" *ngIf="userType!=undefined">
                        <div class="form-group col-md-4" >
                            <label class="col-form-label" for="serviceProviderDesc">Match Score</label>
                            <div class="d-flex">
                                <input type="range" min="1" max="100" step="1" class="form-control-range slider" [value]="sliderValueTemp" id="formControlRange" (input)="valueChanged($event)">   
                                <input for="formControlValue" id="scoreInput" style="width: 50px; margin-left: 5px;" maxlength="3" type="text" (input)="inputChange($event)" [value]="sliderValue" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">  
                            </div>
                        </div>
                      </div>
                        <div class="row d-flex" *ngIf="userType!=undefined">
                            <div class="form-group col-md-4 ">
                                <label class="col-form-label" for="serviceProviderDesc">Search List</label>
                                <!-- <ng-select [multiple]="true" [items]="searchListDropdown" [(ngModel)]="finalSearchList" placeholder="Select Search List" bindLabel="name" bindValue="name"> -->
                                    <!-- <ng-template ng-header-tmp>
                                        <button class="btn btn-primary" (click)="selectAll()" class="btn btn-sm btn-secondary">Select all</button>
                                        <button class="btn btn-primary" (click)="unselectAll()" class="btn btn-sm btn-secondary">Unselect all</button>
                                    </ng-template> -->
                                <!-- </ng-select> -->
                                <ng-select [multiple]="true" bindLabel="title" bindValue="key" (remove)="removeSearchName($event)"
                                (add)="addSearchName($event)" [selectableGroup]="true" [selectableGroupAsModel]="false" id="userType"
                                placeholder="Select Search List" [inputAttrs]="{maxlength: '100'}" [items]="searchListDropdown"
                                [selectableGroup]="true" [closeOnSelect]="false" groupBy="isSelectedALL" [(ngModel)]="finalSearchList"
                                [ngModelOptions]="{standalone: true}">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                                  <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                    [ngModelOptions]="{standalone: true}" />
                                  {{ item.isSelectedALL | uppercase }}
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                  <ng-container *ngIf="item.key !=='ALL'">
                                    <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                      [ngModelOptions]="{standalone: true}" />
                                    {{ item.title }}
                                  </ng-container>
                                </ng-template>
                              </ng-select>
                            </div>

                            <!-- <div class="form-group col-md-4 ">
                                <label class="col-form-label" for="serviceProviderDesc">Search List</label>
                                <ng-select id="userType" [multiple]="true" placeholder="Select Search List" [clearable]="false" (remove)="removeSearchName($event)" (add)="addSearchName($event)">
                                  <ng-option *ngFor="let name of searchListDropdown" value="{{name}}">{{name}}</ng-option>
                                </ng-select>
                            </div> -->
                            <div class="form-group col-md-4 ">
                                <br>
                                <input class="form-check-input" style="margin-top: 10px;" [(ngModel)]="aliasCheck" type="checkbox">
                                <label class=" col-form-label form-check-label" for="creditType" style="margin-left: 5px;"> Enable Alias Search</label>
                            </div>
                            <div class="form-group col-md-4 ">
                                <br>
                                <input class="form-check-input" style="margin-top: 10px;" [(ngModel)]="rcaCheck" type="checkbox">
                                <label class=" col-form-label form-check-label" for="creditType" style="margin-left: 5px;"> Enable RCA Search</label>
                            </div>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="row d-flex" *ngIf="userType!=undefined">
                            <div class="form-group col-md-4 ">
                                <label class="col-form-label" for="serviceProviderDesc">Search List (Digi)</label>
                                <ng-select [multiple]="true" bindLabel="title" bindValue="key" (remove)="removeSearchName($event)"
                                (add)="addSearchName($event)" [selectableGroup]="true" [selectableGroupAsModel]="false" id="userType"
                                placeholder="Select Search List" [inputAttrs]="{maxlength: '100'}" [items]="searchListDigiDropdown"
                                [selectableGroup]="true" [closeOnSelect]="false" groupBy="isSelectedALL" [(ngModel)]="finalSearchListDigi"
                                [ngModelOptions]="{standalone: true}">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                                  <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                    [ngModelOptions]="{standalone: true}" />
                                  {{ item.isSelectedALL | uppercase }}
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                  <ng-container *ngIf="item.key !=='ALL'">
                                    <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                      [ngModelOptions]="{standalone: true}" />
                                    {{ item.title }}
                                  </ng-container>
                                </ng-template>
                              </ng-select>
                            </div>
                        </div>
                     </div>
                        <div class="row d-flex" *ngIf="userType!=undefined">
                            <div class="text-right">
                                <div class="form-group col-md-12">
                                    <button type="button" class="btn btn-primary" (click)="saveConfiguration()">Save</button>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
</div>    
